module.exports = __webpack_public_path__ + "static/media/patrol(32).caaed802.PNG";